import type { BulkEntryState } from './types';

export const emptyBulkBlueCardFilters = {
  selectedYouths: [],
  meritBadgeIds: [],
  advancementStatus: [],
  fromDate: null,
  toDate: null,
};

export const initialState: BulkEntryState = {
  // Shared
  entryType: undefined,
  markAsApproved: false,
  completionDate: undefined,
  validationResults: [],
  selectedVersion: undefined,
  requirements: [],
  selectedScouts: [],
  selectedRequirements: [],
  comment: '',
  // pre-selection (before hits apply)
  preselectedInfo: {
    rank: undefined,
    adventure: undefined,
    meritBadge: undefined,
    version: undefined,
  },
  // Awards
  awardUserRequirements: [],
  selectedAward: undefined,
  // Rank Bulk Entry
  selectedRank: undefined,
  scoutsRankVersionInfo: [],
  // Merit Badge
  selectedMeritBadge: undefined,
  mbEntryType: 'single',
  selectedMeritBadges: [],
  meritBadgeUserRequirements: [],
  // Adventures
  selectedAdventure: undefined,
  adventureUserRequirements: [],
  // Blue Card
  blueCardFilters: emptyBulkBlueCardFilters,
  filteredMeritBadges: [],
  selectedBlueCards: {},
};

export const COMMENT_SUBJECT = 'Bulk Entry Comment';

export enum BLUE_CARD_DISPLAY_STATUS {
  INCOMPLETE = 'incomplete',
  COMPLETE = 'complete',
  INCOMPLETE_AND_COMPLETE = 'incompleteAndComplete',
}

export const NEW_GROUPING_BLUE_CARD_STATUS = [
  { label: 'incomplete', key: BLUE_CARD_DISPLAY_STATUS.INCOMPLETE },
  { label: 'complete', key: BLUE_CARD_DISPLAY_STATUS.COMPLETE },
  {
    label: 'incompleteAndComplete',
    key: BLUE_CARD_DISPLAY_STATUS.INCOMPLETE_AND_COMPLETE,
  },
] as const;
